import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "./assets/css/main.css"
import VueMobileDetection from 'vue-mobile-detection';

const app = createApp(App);
app.use(VueMobileDetection);
app.mount('#app')